<template>
  <div id="leaseagreement">
    <div class="search">
      <div class="cs-searchbar">
        <i class="cs-search"></i>
        <input
          class="form-control"
          :placeholder="i18n.app.components.contract.search"
          v-clearable
          v-model="state.search"
          @clear="
            state.search = '';
            onSearch();
          "
          @keyup.enter.prevent="onSearch(state.search)"
        />
      </div>
    </div>

    <div id="content">
      <h1>{{ i18n.app.common.rent_contracts }}</h1>

      <ContractList
        @columnClick="_setOrderBy($event.key)"
        :column_dict="contractColumnDict"
        :models="pagination.data"
      />

      <div text-center>
        <paginate
          v-if="pagination.last_page"
          v-model="pagination.page"
          :page-count="pagination.last_page"
          :click-handler="_onPageClick"
          :prev-text="i18n.app.pagination.prev"
          :next-text="i18n.app.pagination.next"
          :container-class="'paginator'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ContractList from "./partials/ContractList";
import ContractService from "@/services/ContractService";
import paginationMixin from "@/mixins/pagination.mixin";
import Contract from "../../../models/Contract";
import pick from "lodash/pick";
import { mapGetters } from "vuex";

const constractService = new ContractService();

export default {
  name: "contracts",
  components: {
    ContractList
  },
  mixins: [paginationMixin],
  data() {
    return {
      models: [],
      state: {
        search: ""
      },
    };
  },
  mounted() {
    this.search();

    setInterval(() => this.search(), 300000)
  },
  methods: {
    onOrderBy(column) {
      this.search(this.state.search);
    },
    onPage(data) {
      this.search(this.state.search);
    },
    onSearch(search) {
      this.setPage(1);
      this.search(search);
    },
    async search(search = "") {
      if (!search) search = this.search;
      constractService
        .search(search, { meta: this.getPaginationPostData() })
        .then(pagination => {
          this.pagination = pagination;
        })
        .catch(e => {
          console.log(e);
        });
    },
  },
  computed: {
    ...mapGetters({
      contractColumnDict: "contractColumnDict"
    })
  }
};
</script>
